module.exports = __webpack_public_path__ + "img/your_word_attack_easy.c71db5e9.jpg";